<template>
  <div>
    <h2>{{ title }}</h2>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <input-search />
        <circle-button @click.native="createBannerData"/>
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-center" v-for="header in headers" :key="header.id">
              {{ header.text }}
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(data,index) in dataTable" :key="data.id">
            <td>{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
            <td>{{data.title}}</td>
            <td>{{data.status}}</td>
            <td>{{data.updated_at | moment('DD-MM-YYYY')}}</td>
            <td>
              <a @click="showBannerData(data.id)">
                <icon-pencil/>
              </a>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <paginate :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>
  </div>
</template>

<script>
  import IconPencil from "../../components/Icon/icon-pencil";
  import CircleButton from "../../components/Button/CircleButton";
  import InputSearch from "../../components/Input/InputSearch";
  import Paginate from "../../components/Layout/Paginate";
  export default {
    name: "BannerTable",
    components: {Paginate, InputSearch, CircleButton, IconPencil},
    data() {
      return {
        title: "Banner",
        headers: [
          { id: 1, text: "No." },
          { id: 2, text: "Title" },
          { id: 3, text: "Status" },
          { id: 4, text: "Update date" },
          { id: 5, text: "Edit" },
        ],
        dataTable: [],
        dataPaginate: {
          current_page: 1,
          from: 1,
          last_page: 1,
          per_page: 1,
          total: 1,
          to: 1
        }
      };
    },
    created() {
      this.getBannerTable(1);
    },
    methods:{
      getBannerTable(page){
        this.$store.dispatch("Banner/getBanner",page).then(res=>{
          if(res.response_code == 200){
            this.dataTable = res.result.data;
            this.dataPaginate = {
              current_page: res.result.current_page,
              from: res.result.from,
              last_page: res.result.last_page,
              per_page: res.result.per_page,
              total: res.result.total,
              to: res.result.to
            }
          }
        }).catch(()=>{
          alert("cannot get Banner data");
        })
      },

      changePage(val){
        this.dataPaginate.current_page = val;
        this.$store.dispatch("Banner/getBanner", this.dataPaginate.current_page).then(res => {
          if (res.response_code == 200) {
            this.dataTable = res.result.data;
            this.dataPaginate = {
              current_page: res.result.current_page,
              from: res.result.from,
              last_page: res.result.last_page,
              per_page: res.result.per_page,
              total: res.result.total,
              to: res.result.to
            }
          } else {
            alert(res.response_msg);
          }
        });
      },
      goToBannerEdit(){
        this.$router.push("/banner/edit");
      },
      showBannerData(id){
        this.$store.dispatch("Banner/showBanner",id).then(res=>{
          if(res.response_code == 200){
            this.$store.dispatch("Banner/setFormBanner",res.result).then(()=>{
              this.goToBannerEdit();
            })
          }
        }).catch(()=>{
          alert("cannot get Banner data");
        });
      },
      createBannerData(){
        this.$store.dispatch("Banner/clearFormData").then(()=>{
          this.goToBannerEdit();
        });
      },

    }
  }
</script>

<style scoped>
  .branch-data {
    background-color: transparent;
    margin: 20px;
  }
</style>
